import SidebarSectionAction from './SidebarSectionAction';
import SidebarSectionContent from './SidebarSectionContent';
import SidebarSectionDescription from './SidebarSectionDescription';
import SidebarSectionHeader from './SidebarSectionHeader';
import SidebarSectionRoot from './SidebarSectionRoot';
import SidebarSectionTitle from './SidebarSectionTitle';

export * from './SidebarValue';
export * from './SidebarValueBui';

export const SidebarSection = {
  Root: SidebarSectionRoot,
  Header: SidebarSectionHeader,
  Content: SidebarSectionContent,
  Title: SidebarSectionTitle,
  Description: SidebarSectionDescription,
  Action: SidebarSectionAction,
};
